import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    shareEntity as shareEntityApi,
    ShareEntityApiParameter,
    shareEntityGenerateFromWebpage,
} from "@insite/client-framework/Services/EmailService";
import { ShareEntityParameter } from "@insite/client-framework/Store/CommonHandlers/ShareEntity";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ShareEntityModel } from "@insite/client-framework/Types/ApiModels";

import {
    chain,
    SendDataToApi,
} from "@insite/client-framework/Store/CommonHandlers/ShareEntity";

type HandlerType = ApiHandlerDiscreteParameter<ShareEntityParameter, ShareEntityApiParameter, ShareEntityModel>;

export const SendDataToApiCustom: HandlerType = async props => {
    const {
        parameter: { generateAttachmentFromWebpage, shareEntityModel },
        apiParameter,
    } = props;

    const location = getLocation(props.getState());
    const params = new URLSearchParams(location.search);

    const podImages = (shareEntityModel as any).podimages;
    if (shareEntityModel.entityName.toLowerCase() === "order" && podImages) {
        params.set("podimages", "true");
    }
    const urlPath = location.pathname + (params.toString() ? `?${params.toString()}` : "");

    props.apiResult = generateAttachmentFromWebpage
        ? await shareEntityGenerateFromWebpage({
            shareEntityModel,
            urlPathToLoadForAttachmentHtml: urlPath,
        })
        : await shareEntityApi(apiParameter);
};

replaceInChain(chain, SendDataToApi, SendDataToApiCustom);